/* eslint-disable no-unused-vars */
import { Nullable } from 'src/types/nullable.type';
import { create } from 'zustand';

export enum FreeGatingEnum {
  ORG = 'org',
  WORKSPACE = 'workspace',
  JOURNEYS = 'journeys',
  ORG_TEMPLATES = 'org_templates',
  PRESENTATION_MODE = 'presentation_mode',
  FREE_JOURNEYS = 'free_journeys'
}

const FreeGatingModalContentMapping: Record<FreeGatingEnum, string> = {
  [FreeGatingEnum.ORG]: 'Our Grow plan gives you unlimited organizations, plus all the features of Starter Plan.',
  [FreeGatingEnum.WORKSPACE]: 'Our Grow plan gives you unlimited workspaces, plus all the features of our Starter plan.',
  [FreeGatingEnum.FREE_JOURNEYS]: 'Delete existing journeys or upgrade to Grow plan to create unlimited journeys.',
  [FreeGatingEnum.JOURNEYS]: 'Our Grow plan gives you unlimited Journeys, plus all the features of our Starter plan.',
  [FreeGatingEnum.ORG_TEMPLATES]: 'Our Scale plan gives you option to create organization templates, plus all the features of our Grow plan.',
  [FreeGatingEnum.PRESENTATION_MODE]: 'Our Grow plan gives you option to create journeys in presentation mode, plus all the features of our Starter plan.'
};

export const FreeGatingModalTooltipContentMapping = {
  [FreeGatingEnum.ORG]: 'Upgrade to get access to unlimited organizations',
  [FreeGatingEnum.WORKSPACE]: 'Upgrade to get access to unlimited workspaces',
  [FreeGatingEnum.JOURNEYS]: 'Upgrade to get access to unlimited journeys',
  [FreeGatingEnum.FREE_JOURNEYS]: 'Upgrade or delete existing journeys to create more journeys',
  [FreeGatingEnum.ORG_TEMPLATES]: 'Upgrade to get access to organization templates',
  [FreeGatingEnum.PRESENTATION_MODE]: 'Upgrade to get access to presentation mode'
};

const initialState = {
  modalContent: FreeGatingModalContentMapping[FreeGatingEnum.JOURNEYS],
  tooltipContent: FreeGatingModalTooltipContentMapping[FreeGatingEnum.JOURNEYS],
  showModal: false,
  isLocked: false,
  type: FreeGatingEnum.JOURNEYS,
};

export const useFreeGatingStore = create<{
  showModal: boolean;
  modalContent: Nullable<string>;
  tooltipContent: string;
  isLocked: boolean;
  type: FreeGatingEnum;
  setFreeGatingModalByType: (type: FreeGatingEnum, showModal: boolean, isLocked?: boolean) => void;
  reset: () => void;
}>((set) => ({
  ...initialState,
  setFreeGatingModalByType: (type, showModal, isLocked = false) => {
    set({
      showModal,
      isLocked,
      modalContent: type === null ? null : FreeGatingModalContentMapping[type],
      tooltipContent: type ? FreeGatingModalTooltipContentMapping[type] : '',
      type,
    });
  },
  reset: () => {
    set({ ...initialState, modalContent: null });
  },
}));
